import React from "react";
import {useTranslation} from "react-i18next";

import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

import {base64toBlob} from "../Home/utils";
import {BaseDataType} from "../Home/ApplicationDetails/types";
import {mb} from "./const";

const FullscreenDialog = React.lazy(() => import("../Home/ApplicationDetails/ImageZoom/FullscreenDialog"));

type ImageParams = {
    url:string|null,
    title?:string,
    baseData: BaseDataType
    recruitEmail: string;
    mandate: number;
}

const File: React.FC<ImageParams> = ({url, title, baseData, recruitEmail, mandate}) => {
    const {t} = useTranslation('common');

    const [error, setError] = React.useState<boolean>(false);
    const [fileData, setFileData] = React.useState<string>("");
    const [fileType, setFileType] = React.useState<string>("");
    const [open, setOpen] = React.useState<boolean>(false);
    const [rotationInDrawer, setRotationInDrawer] = React.useState<number>(0);
    const [largeFile, setLargeFile] = React.useState<boolean>(false);
    const [urlBlob, setUrlBlob] = React.useState<string>("");


    const handleOpen = () => {
        setOpen(true);
        loadFileData(url);
    };

    const loadFileData =  (url:any) => {
         fetch(url).then(response => {
            if(response.ok){
                response.text().then((text) => {
                    setFileType(text.split(':')[1].split(';')[0]);
                    setFileData(text);
                    if(text.length > mb) {
                        setLargeFile(true)
                    }
                }).catch(()=>{
                    setError(true);
                })
            } else {
                setError(true);
            }
        }).catch(()=>{
            setError(true);
        });
    }

    const closeFullscreen = () => {
        setOpen(false)
        if(largeFile && urlBlob){
            URL.revokeObjectURL(urlBlob); // remove from memory
            setUrlBlob("");
            setLargeFile(false);
        }
    }

    //only use blob if it is large file
    React.useEffect( () => {
        if(largeFile){
            let blob = base64toBlob(fileData, fileType);
            setUrlBlob(() => URL.createObjectURL(blob));
        }
    }, [largeFile, fileData, fileType])

    if (error) {
        return <div>
            <Alert severity="error">{t("error_occurred")}</Alert>
        </div>
    }

    return(
        <>
            <Button variant="outlined" onClick={handleOpen}>
                {title ? title : "Dokument öffnen"}
            </Button>
            <FullscreenDialog fileData={urlBlob ? urlBlob:fileData} openFullScreen={open} closeFullscreen={closeFullscreen}
                              baseData={baseData} recruitEmail={recruitEmail} fileType={fileType} mandate={mandate}
                              rotationInDrawer={rotationInDrawer} setRotationInDrawer={setRotationInDrawer}/>
        </>
    );
}

export default File;